import reportsConfig from '~/constants/data-reports/anode'

const priceAnodeData = {
  hero: reportsConfig.hero,
  descriptions: [
    'Our Price Assessments draw on Benchmark’s proprietary databases, tracking every global production facility, capacity expansions, technology developments and industry partnerships to provide clarity to the complex lithium ion battery landscape.',
  ],
  descriptionImage:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/q_auto,f_auto/v1719441567/assets/market/anode/prices/benchmarkminerals_batteries_photo_photorealistic_Hyper-realism__a48990a8-df95-4a76-bf5d-8f81a0476848_wbrsos.png',
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Access to exclusive Anode data, with company and regional capacity, and supply demand/analytics',
    },
    {
      icon: 'services/icon-report',
      description:
        'Monthly report providing Anode prices and insights to reveal the direction of the midstream battery sector',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-global',
      description:
        'A global perspective on the evolution of the Anode industry.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  brochureFile: {
    file_name: 'Benchmark-Anode-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'anodePriceAssessmentsMethodologyId',
  },
  indexTab: true,
  requiredFilters: ['categories', 'shippingRoutes', 'purities', 'priceTypes'],
}
export default priceAnodeData
